import React, { useContext, useEffect, useState } from 'react';
import Modal from 'react-modal';
import CsvReader from '../../components/CsvReader';
import { BeneficiaryContext } from '../../contexts/BeneficiaryContext';
import ViewGroup from './ViewGroup';

Modal.setAppElement('#root');

export default function GroupCard({ item }) {
  const { loadGroupBeneficiaries } = useContext(BeneficiaryContext);
  const [entries, setEntries] = useState(0);
  const [viewModal, setViewModal] = useState(false);
  const openModal = () => setViewModal(true);
  const closeModal = () => setViewModal(false);

  useEffect(() => {
    loadGroupBeneficiaries(item.id).then((res) => setEntries(res.length));
  }, []);

  return (
    <div className={'w-full lg:w-1/3 p-2'}>
      <ViewGroup viewModal={viewModal} closeModal={closeModal} data={item} />
      <div className={'bg-gray-200 p-5'}>
        <div className={'flex flex-row justify-between items-center'}>
          <h3 className={'font-medium text-lg mr-2'}>{item.group_name}</h3>
          <button
            onClick={openModal}
            className={'cursor-pointer px-4 py-2 rounded bg-yellow-500'}
          >
            View
          </button>
        </div>
        <hr className={'border-t border-gray-400 my-3'} />
        <p className={'text-lg'}>{item.description}</p>
        <div
          className={'flex flex-col justify-center items-center h-full py-5'}
        >
          <div className={'mb-2'}>
            <p className={'text-lg'}> {entries} entries</p>
          </div>
          <CsvReader groupId={item.id} />
        </div>
      </div>
    </div>
  );
}
